// extracted by mini-css-extract-plugin
module.exports = {"root":"Collaborators__root___3DcSt","collaborator":"Collaborators__collaborator___8b63m"};